import React from "react";
import styled, { withTheme } from "styled-components/macro";
import { darken } from "polished";
// import { Search as SearchIcon } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";

import bmrlogo from '../assets/platform_logo.svg';

import {
  Grid,
  Hidden,
  InputBase,
  AppBar as MuiAppBar,
  IconButton as MuiIconButton,
  Toolbar,
  Button,
} from "@material-ui/core";

import { Menu as MenuIcon } from "@material-ui/icons";
import { useDispatch, useTrackedState } from "../system/store";

import PlAlert from '../components/Alert';

// import NotificationsDropdown from "./NotificationsDropdown";
// import MessagesDropdown from "./MessagesDropdown";
// import LanguagesDropdown from "./LanguagesDropdown";
// import UserDropdown from "./UserDropdown";

const AppBarComponent = ({ onDrawerToggle }) => {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0();
  const dispatch = useDispatch();
  const { user, message } = useTrackedState();

  return (
    <React.Fragment>
      <PlAlert message={message}/>
      <AppBar position="sticky" elevation={0}>
        <Toolbar>
        
          <Grid container alignItems="center">
            {/* <Hidden mdUp> */}
            {isAuthenticated && 
              <Grid item>
                <IconButton
                  color="inherit"
                  aria-label="Open drawer"
                  // onClick={onDrawerToggle}
                  onMouseEnter={onDrawerToggle}
                >
                  <MenuIcon/>
                </IconButton>
              </Grid>
            }
            
            {/* </Hidden> */}
            <Grid item>
              {/* <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <Input placeholder="Search topics" />
              </Search> */}
            </Grid>
            <Grid item xs />
            <Grid item>
            {isAuthenticated && 
            <Button
            onClick={()=>{dispatch({ type: "SET_USER_EDIT", userEdit: user }); dispatch({ type: "SET_PAGE", page: "/adm/profile" })}}
          >
            Profile
          </Button>
            }
            
 

              {isAuthenticated ? (
                <Button
                  onClick={() => logout({ returnTo: window.location.origin })}
                >
                  Logout
                </Button>
              ) : (<>
                <Button
              href="https://rdi.bright-research.com/bright-platform"
              variant="contained"
              color="primary"
              size="large"
              target="_blank"
            >
              Learn More
            </Button>
                <Button onClick={() => loginWithRedirect()}>Login</Button>
                </>
              )}
              
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
    </React.Fragment>
  );
};

const AppBar = styled(MuiAppBar)`
  background: ${(props) => props.theme.header.background};
  color: ${(props) => props.theme.header.color};
`;

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Search = styled.div`
  border-radius: 2px;
  background-color: ${(props) => props.theme.header.background};
  display: none;
  position: relative;
  width: 100%;
  &:hover {
    background-color: ${(props) => darken(0.05, props.theme.header.background)};
  }
  ${(props) => props.theme.breakpoints.up("md")} {
    display: block;
  }
`;

const SearchIconWrapper = styled.div`
  width: 50px;
  height: 100%;
  position: absolute;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 22px;
    height: 22px;
  }
`;

const Input = styled(InputBase)`
  color: inherit;
  width: 100%;
  > input {
    color: ${(props) => props.theme.header.search.color};
    padding-top: ${(props) => props.theme.spacing(2.5)}px;
    padding-right: ${(props) => props.theme.spacing(2.5)}px;
    padding-bottom: ${(props) => props.theme.spacing(2.5)}px;
    padding-left: ${(props) => props.theme.spacing(12)}px;
    width: 160px;
  }
`;

export default withTheme(AppBarComponent);
